import React, { useEffect, useState } from 'react';
import { color, Stack } from '@starrez/starryui9';
import { ICellRenderer } from '../types';
import styled from 'styled-components';
import { ColDef } from 'ag-grid-community';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RowEvent = (value: boolean, data: any) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type HeaderEvent = (value: boolean, data: any) => void;

interface ISelectionColumnProps extends ICellRenderer<boolean> {
    onRowClick: RowEvent;
    onAllRowsClick: HeaderEvent;
}

export const SelectionColumn = ({ value, node, data, onRowClick }: ISelectionColumnProps) => {
    const [checked, setChecked] = useState(value);

    useEffect(() => {
        node?.setSelected(value);
        setChecked(value)
    }, [value]);

    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        node?.setSelected(value);
        onRowClick(!checked, data);
        setChecked(!checked);
    };

    return (
        <Stack height="100%">
            {checked ? (
                <CheckedButton aria-label="Un-Select Row" type="button" role="checkbox" aria-checked="true" onClick={handleOnClick}>
                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.90427 0.528636C6.16462 0.268287 6.58673 0.268287 6.84708 0.528636C7.10742 0.788986 7.10742 1.2111 6.84708 1.47145L3.18041 5.13811C2.92006 5.39846 2.49795 5.39846 2.2376 5.13811L0.570934 3.47144C0.310584 3.2111 0.310584 2.78899 0.570934 2.52864C0.831283 2.26829 1.25339 2.26829 1.51374 2.52864L2.709 3.7239L5.90427 0.528636Z"
                            fill="white"
                        />
                    </svg>
                </CheckedButton>
            ) : (
                <UnCheckedButton aria-label="Select Row" type="button" role="checkbox" aria-checked="false" onClick={handleOnClick}></UnCheckedButton>
            )}
        </Stack>
    );
};

const CheckedButton = styled.button`
    background: ${color.Blue.B60};
    height: 16px;
    width: 16px;
    border: 2px solid ${color.Blue.B60};
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const UnCheckedButton = styled.button`
    background: white;
    height: 16px;
    width: 16px;
    border: 2px solid ${color.Grey.G40};
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        border-color: ${color.Blue.B60};
    }
`;

export function useSelectionColumn(onRowClick: RowEvent, onAllRowsClick: HeaderEvent): ColDef {
    return {
        cellRendererFramework: SelectionColumn,
        headerComponentFramework: SelectionColumn,
        cellRendererParams: {
            onRowClick,
        },
        headerComponentParams: {
            onRowClick: onAllRowsClick,
        },
        headerName: '',
        width: 50,
        sortable: false,
        resizable: false,
        cellClass: 'no-border'
    };
}
